import { cn } from "@/lib/utils";
import type { SVGProps } from "react";

/** Compact Cohesive glyph for public-view chrome (header + mark menu). */
export function CohesiveMark({
  className,
  size = 17,
  ...props
}: SVGProps<SVGSVGElement> & { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 54 59"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      className={cn("shrink-0", className)}
      {...props}
    >
      <path
        d="M18.16 6.572h.045v36.2h-.046C8.136 42.773 0 34.664 0 24.673c0-9.99 8.136-18.1 18.16-18.1ZM26.603 58.997 16.287 48.715 36.01 29.056l.234.234c5.564 5.545 5.564 14.551 0 20.097L26.6 59l.004-.003ZM30.497 0l18.344 18.283a7.26 7.26 0 0 1 0 10.285c-2.846 2.837-7.47 2.84-10.319 0L20.179 10.285 30.497 0Z"
        fill="currentColor"
      />
    </svg>
  );
}
